export var BuilderConfig = {
    name: "FoundationIcon",
    relativePath: "./FoundationIcon.tsx",
    propDefinition: {
        name: "IFoundationIconProps",
        path: "./FoundationIcon.tsx"
    },
    defaultValues: {
        fontSize: 14,
        iconName: "Account"
    },
    canHaveChildren: false
};
